/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateServiceDocumentDraftDto = {
  /**
   * 문서 타입
   */
  type: CreateServiceDocumentDraftDto.type;
  /**
   * 내용을 복제할 원본 리비전 ID — 미지정 시 해당 타입 최신 배포본(없으면 빈 문서)
   */
  fromRevisionId?: string;
};
export namespace CreateServiceDocumentDraftDto {
  /**
   * 문서 타입
   */
  export enum type {
    TERMS = "terms",
    PRIVACY = "privacy",
    MARKETING = "marketing",
  }
}
